import { useMemoizedFn } from 'ahooks';
import { LayoutTable } from 'xui-pro';
import type { TableRecord } from 'xui-pro/es/LayoutTable';
import type { Definition } from '@/api/sip/bookmap/circuitInfoUsingPOST';
import { useColumns } from './useConfig';
import { useEffect, useRef } from 'react';

type Props = {
  tableData: Definition[];
  selectPCode: string;
  setSelectPCode: (pcode: string) => void;
  definitionColumnList?: string[];
};
const CircuitTable = ({ tableData, selectPCode, setSelectPCode, definitionColumnList }: Props) => {
  const tableRef = useRef<HTMLDivElement>(null);
  const columns = useColumns(definitionColumnList);
  const isInternalTrigger = useRef(false); // 是否table内部点击触发

  const onClickCell = useMemoizedFn((item: TableRecord<Definition>) => {
    isInternalTrigger.current = true;
    setSelectPCode(item.record.pcode);
  });
  const onRowSelectionChange = useMemoizedFn(selectedRowKeys => {
    isInternalTrigger.current = true;
    setSelectPCode(selectedRowKeys[1] as string);
  });

  /**
   * @desc 外部触发selectPCode变化，table滚动到选中行
   */
  useEffect(() => {
    if (isInternalTrigger.current) {
      isInternalTrigger.current = false;
      return;
    }
    const handleScrollToRow = () => {
      const rows = tableRef.current?.querySelectorAll('.ant-table-row');
      if (rows) {
        for (let i = 0; i < rows.length; i++) {
          const row = rows[i] as HTMLTableRowElement;
          const pcode = row.getAttribute('data-row-key');
          if (pcode === selectPCode) {
            const container = tableRef.current?.querySelector('.ant-table-body');
            if (container) {
              const rowTop = row.offsetTop + (row.offsetParent as HTMLElement)?.offsetTop - 38;
              container.scrollTo({ top: rowTop, behavior: 'smooth' });
            }
            break;
          }
        }
      }
    };
    const animationFrameId = requestAnimationFrame(handleScrollToRow);
    return () => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
    };
  }, [selectPCode]);

  return (
    <div ref={tableRef}>
      <LayoutTable
        dataSource={tableData}
        hasActionRowVisitedStyle={true}
        pagination={false}
        hasToolbar={false}
        onCellClick={onClickCell}
        rowSelection={{
          selectedRowKeys: [selectPCode],
          onChange: onRowSelectionChange
        }}
        rowKey={record => record.pcode}
        height={200}
        columns={columns}
        hasEmptyPlaceholder={true}
        emptyPlaceholder='-'
      />
    </div>
  );
};

export default CircuitTable;
